/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = PERCENTAGE
 *
 * 1 = GROSSVALUE
 */
export enum CDKDiscountType {
  PERCENTAGE = 0,
  GROSSVALUE = 1,
}
